import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    commentRoot: {
      borderBottom: "1px solid #eee",
      cursor: "pointer",
      "&.modalView": {
        borderBottom: "none",
        cursor: "default"
      }
    },
    headerRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: 500,
      height: 22,
      color: primary.main,
      marginBottom: 6,
      "&.modalView": {
        marginBottom: 9
      }
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: 12,
      color: primary.dark,
      marginBottom: 5,
      "&.modalView": {
        marginBottom: 9
      }
    },
    commentContent: {
      fontSize: 12,
      color: "#333",
      lineHeight: "17px",
      wordBreak: "break-word",
      "&.modalView": {
        fontSize: 14,
        lineHeight: "19px",
        height: 167,
        overflowY: "auto"
      }
    },
    mark: {
      visibility: "hidden",
      width: 10,
      height: 10,
      borderRadius: "50%",
      backgroundColor: theme.palette.warning.dark,
      "&.unread": {
        visibility: "visible"
      }
    },
    commenterInfo: {
      display: "flex",
      alignItems: "center",
      "&.modalView": {
        color: primary.main,
        fontSize: 16
      }
    },
    info: {
      textTransform: "capitalize",
      "&.inlineDisplaying": {
        display: "flex"
      }
    },
    eventInfo: {
      textAlign: "end"
    },
    additionalSigns: {
      display: "none",
      "&.inlineDisplaying": {
        display: "initial"
      }
    },
    icon: {
      width: 13,
      marginRight: 8,
      "&.modalView": {
        width: 16,
        marginBottom: 2
      }
    },
    uppercase: {
      textTransform: "uppercase"
    }
  };
});
